/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'red-circle-x-mark': {
    width: 14,
    height: 15,
    viewBox: '0 0 14 15',
    data: '<circle pid="0" cx="7" cy="7.5" r="7" _fill="#D26568"/><path pid="1" fill-rule="evenodd" clip-rule="evenodd" d="M4.074 4.712a.367.367 0 0 1 .52-.013L7 6.992l2.406-2.293a.367.367 0 0 1 .55.482l-.043.05-2.38 2.268 2.38 2.269.044.05a.368.368 0 0 1-.55.482L7 8.007 4.593 10.3a.367.367 0 0 1-.55-.482l.044-.05 2.38-2.269-2.38-2.268-.044-.05a.367.367 0 0 1 .031-.47z" _fill="#fff"/>'
  }
})
